import { render, staticRenderFns } from "./VotersList.vue?vue&type=template&id=41d30c78&scoped=true&"
import script from "./VotersList.vue?vue&type=script&lang=js&"
export * from "./VotersList.vue?vue&type=script&lang=js&"
import style0 from "./VotersList.vue?vue&type=style&index=0&id=41d30c78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d30c78",
  null
  
)

export default component.exports